import PropTypes from 'prop-types'
import React from 'react'
import { Icon } from 'Blocks'
import { path } from 'Utils'
import { PAGE_CONTEXT as p } from 'Constants'

const SearchBox = props => {
  const {
    /* SYSTEM */
    className = '',
    title = '',
    searchPlaceholderText = '',
    style = {}
  } = props

  const searchUrl = path(p.PRODUCT_LIST, {
    uuid: process.env.ANT_BROWSE_ID,
    subCategory: 'search'
  })
  return (
    <div {...{ className, style }}>
      <div>
        <h3>{title}</h3>
      </div>
      <form role="search" action={searchUrl}>
        <input
          placeholder={searchPlaceholderText}
          type="search"
          name="term"
          autoComplete="off"
        />
      </form>
    </div>
  )
}

SearchBox.propTypes = {
  className: PropTypes.string,
  searchPlaceholderText: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string
}

const Search = ({ closeDialog = () => {} }) => (
  <div>
    <header>
      <Icon className="close-modal" name="close" onClick={closeDialog} />
    </header>
    <SearchBox
      className="search-wrapper-modal"
      title="search products"
      searchPlaceholderText="I am looking for ..."
    />
  </div>
)

Search.propTypes = {
  closeDialog: PropTypes.func
}

export default Search
